import MuiTab from '@mui/material/Tab';
import MuiTabs from '@mui/material/Tabs';
import { AdminCompanyInformation } from '@src/clients/CompanyInformation';
import type { Client } from '@src/clients/domain/Client';
import { ClientUsersTable } from '@src/clientUser/manage/ClientUsersTable';
import { PageLayout } from '@src/common/components/Page';
import { Stack } from '@src/common/components/Stack';
import { DriversList } from '@src/driver/DriversList';
import { TabPanel } from '@src/orders/TabPanel';
import { ClientsNavigation } from '@src/routing/ClientsNavigation';
import { TractorsList } from '@src/tractor/TractorsList';
import { TrailersList } from '@src/trailer/TrailersList';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { FinancialSettings } from './FinancialSettings';

interface Props {
  client: Client;
  refreshData: () => void;
}

export function ClientPage({ client, refreshData }: Props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentTab, setCurrentTab] = useState(
    searchParams.get(ClientsNavigation.get.searchParamKey)
      ? parseInt(searchParams.get(ClientsNavigation.get.searchParamKey)!)
      : 0,
  );
  const { t } = useTranslation();

  const handleTabChange = (index: number) => {
    setCurrentTab(index);
    searchParams.set(ClientsNavigation.get.searchParamKey, index.toString());
    setSearchParams(searchParams);
  };

  const tabProps = (tabNumber: number) => {
    return {
      id: `horizontal-tab-${tabNumber}`,
      'aria-controls': `horizontal-tabpanel-${tabNumber}`,
    };
  };
  return (
    <PageLayout title={client.name}>
      <MuiTabs
        variant="fullWidth"
        TabIndicatorProps={{ style: { height: '1px' } }}
        sx={{ marginBottom: 4 }}
        value={currentTab}
        onChange={(_, index) => handleTabChange(index)}
      >
        <MuiTab label={t('companyInformation')} {...tabProps(0)} />
        <MuiTab label={t('financialSettings')} {...tabProps(1)} />
        <MuiTab label={t('drivers')} {...tabProps(2)} />
        <MuiTab label={t('tractors')} {...tabProps(3)} />
        <MuiTab label={t('trailers')} {...tabProps(4)} />
        <MuiTab label={t('clientUsers.tabTitle')} {...tabProps(5)} />
      </MuiTabs>
      <Stack>
        <TabPanel index={0} value={currentTab}>
          <AdminCompanyInformation client={client} />
        </TabPanel>
        <TabPanel index={1} value={currentTab}>
          <FinancialSettings client={client} refreshData={refreshData} />
        </TabPanel>
        <TabPanel index={2} value={currentTab}>
          <DriversList clientId={client.id} />
        </TabPanel>
        <TabPanel index={3} value={currentTab}>
          <TractorsList clientId={client.id} />
        </TabPanel>
        <TabPanel index={4} value={currentTab}>
          <TrailersList clientId={client.id} />
        </TabPanel>
        <TabPanel index={5} value={currentTab}>
          <ClientUsersTable client={client} />
        </TabPanel>
      </Stack>
    </PageLayout>
  );
}
